<template>
  <!-- 发件箱 -->
  <div class="inbox outboxs">
    <div class="top_center">
      <div class="inlbox">
        <div class="title_top flex">
          <div class="title flex">
            <div class="title_input">
              <el-input
                v-model="receiverName"
                placeholder="联盟客姓名"
              ></el-input>
              <div class="icons">
                <img src="../../assets/img/foll/search.png" alt="" />
              </div>
            </div>
            <div class="title_ks">
              <div class="block">
                <el-date-picker
                  v-model="values"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="选择开始日期"
                  end-placeholder="选择结束日期"
                  @change="startDa"
                >
                </el-date-picker>
                <img src="@/assets/img/emil/rl.png" alt="" />
              </div>
            </div>
            <div class="title_scslt">
              <el-select
                v-model="isRead"
                clearable
                placeholder="是否已读"
                @clear="delValue"
              >
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </div>
          </div>
          <div class="title_qu">
            <div
              class="title_query ba6e coff center ru5 cursor"
              @click="searchs"
            >
              查询
            </div>
          </div>
        </div>
        <!-- <div> -->
        <div class="list baff ru5 flex">
          <div class="fixedLef" @click="chooseAllCart">
            <input
              type="checkbox"
              :checked="chooseAll"
              @change="ctinput"
              name
              id
            />
          </div>
          <span class="detale cursor" @click="detaile">删除</span>
          <p class="fj">收件人</p>
          <p class="zt">主题</p>
          <p class="sj center">时间</p>
        </div>
        <div>
          <div
            class="list_map baff ru5 flex cursor"
            v-for="(item, index) in emaiList"
            :key="index"
            :class="inboxStuts == index ? 'bacc' : ''"
            @click="inboxlist(index)"
          >
            <input
              type="checkbox"
              :checked="item.choose"
              name
              id
              class="oneCheck"
              @click="chooseOne(index, item)"
            />
            <div class="fj flex" @click="detaleemwi(item)">
              <div class="ru50">
                <img
                  class="ru50"
                  :src="item.headSrc"
                  alt=""
                  @click="godetil(item)"
                />
              </div>

              <p @click="detaleemwi(item)" class="receivename">
                {{ item.name }}
              </p>
            </div>
            <div class="zt flex" @click="detaleemwi(item)">
              <!-- <div class="zt_stuss center co6e sz12" v-if="(item.isRead == 0)">未读</div> -->
              <!-- <div class="zt_stuss center co6e sz12" v-if="(item.isRead == 1)">已读</div> -->
              <p class="bark">{{ item.subject }}-</p>
              <p class="bark_two">{{ item.abstractContent }}</p>
            </div>
            <div class="sj">
              <div class="flex">
                <!-- <p class="sj_text">08:13 </p> -->
                <p class="sj_img">
                  <span>{{ item.createTime }}</span>
                  <img
                    class="cursor"
                    v-if="item.isStarMark == 0"
                    src="@/assets/img/emil/kx.png"
                    alt=""
                    @click.stop="starMark(item)"
                  />
                  <img
                    class="cursor"
                    v-if="item.isStarMark == 1"
                    src="@/assets/img/emil/sx.png"
                    alt=""
                    @click.stop="starMark(item)"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="read cursor ba6e coff center sz16" v-if="isReadstusts">全部已读</div> -->
        <!-- <div v-if="readAll" class="read cursor ba6e coff center sz16" @click="allRead">全部已读</div> -->
        <div class="pages" v-if="emaiList.length">
          <Pagination
            :pageNo="currentPage"
            :pageSize="size"
            :total="total"
            :continues="4"
            @getPageNo="currentChangeTwo"
          />
        </div>
        <div class="list_map baff ru5 center" v-if="!emaiList.length">
          暂无数据
        </div>
        <!-- </div> -->
      </div>
      <div class="drawer_center">
        <el-drawer
          title=""
          :visible.sync="drawer"
          direction="rtl"
          :size="widthSize"
          :before-close="handleCloses"
          :modal="false"
        >
          <div class="drawer_top">
            <!-- <div class="drawer_title flex"> -->
            <div class="drawer_img">
              <img
                v-if="zkstyts == 1"
                class="cursor"
                src="@/assets/img/emil/zk.png"
                alt=""
                @click="widthclice(1)"
              />
              <img
                v-if="zkstyts == 2"
                class="cursor"
                src="@/assets/img/emil/sq.png"
                alt=""
                @click="widthclice(2)"
              />
            </div>
            <div v-if="detaStuts == 1">
              <div class="emilconten_top flex">
                <div class="emilconten ru50">
                  <img class="ru50" :src="emeildetail.headSrc" alt="" />
                </div>
                <div class="emilconten_xb">
                  <div class="emilconten_xb_img flex">
                    <img
                      class="cursor"
                      v-if="emeildetail.isStarMark == 0"
                      src="@/assets/img/emil/kx.png"
                      alt=""
                      @click="starMarkDe(emeildetail)"
                    />
                    <img
                      class="cursor"
                      v-if="emeildetail.isStarMark == 1"
                      src="@/assets/img/emil/sx.png"
                      alt=""
                      @click="starMarkDe(emeildetail)"
                    />
                    <div>{{ emeildetail.name }}</div>
                  </div>
                  <div class="emilconten_xb_img flex">
                    <div>{{ emeildetail.createTime }}</div>
                  </div>
                </div>
              </div>
              <p
                class="createTimeS_bt sz18 feont_bo"
                style="margin-bottom: 20px"
              >
                {{ emeildetail.subject }}
              </p>
              <!-- {}} -->
              <p
                style="max-width: 1920px"
                v-html="emeildetail.dealEmailContentHtml"
              ></p>
              <div class="sendOuts" :class="widthstuts == 1 ? 'w35' : 'w65'">
                <div class="statement flex">
                  <div class="submit_top">
                    <div class="submit center ba6e coff ru5">
                      <div
                        class="center ba6e coff ru5 sz14 cursor"
                        @click="detaShf"
                      >
                        再发一封
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="create_hf">
                <div class="center coff ba6e cursor" @click="detaShf">再发一封</div>
              </div> -->
            </div>
            <div class="drawer_top" v-if="detaStuts == 2">
              <div class="addressee">收件人</div>
              <div class="addressee">
                <el-input v-model="name" disabled></el-input>
              </div>
              <div class="addressee">主题</div>
              <div class="addressee_input">
                <el-input v-model="subject" maxlength="50"></el-input>
              </div>
              <div class="templates">
                <div class="cursor templates_top">
                  <el-button
                    type="primary"
                    icon="el-icon-setting"
                    @click="openTemplateM"
                    >管理模板</el-button
                  >
                  <el-dropdown size="small" trigger="click">
                    <div class="templates_selice ru5">
                      选择模板
                      <i class="el-icon-caret-bottom co6e"></i>
                    </div>
                    <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                      <div class="templates_list ru5" style="min-width: 165px">
                        <div
                          class="lists center sz16 cursor"
                          v-for="(item, index) in templatesList"
                          :key="index"
                          @click="selicetem(item)"
                        >
                          {{ item.name }}
                        </div>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div class="addressee">正文</div>
              <div style="border: 1px solid #ccc; margin-bottom: 100px">
                <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                  :mode="mode"
                />
                <Editor
                  style="
                    min-height: 500px;
                    width: 100%;
                    overflow-y: hidden;
                    background: #fff;
                  "
                  v-model="html"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                  @onCreated="onCreated"
                  @onChange="onChange"
                />
              </div>
              <div class="sendOut w100">
                <div>
                  <div class="statement flex">
                    <div class="flex statement_p">
                      <p class="statement_text">
                        Tips：平台接受处理违规信息的联系方式为：support@foshobrands.com
                      </p>
                      <p
                        class="statement_img center ru50 co6e cursor"
                        @mouseenter="mouseover"
                        @mouseleave="mouseout"
                      >
                        ?
                      </p>
                      <div
                        class="statement_pre"
                        v-show="statementStuts == 1"
                        @mouseenter="mouseover"
                        @mouseleave="mouseout"
                      >
                        <p>
                          平台声明：平台尽最大努力采取技术措施和组织措施，在提供给客户的信息
                        </p>
                        <p>
                          或内容中，过滤或删除任、何违反中华人民共和国法律法规或有损害中华人
                        </p>
                        <p>
                          民共和国国家安全、政治安全或丑化、侮辱中华人民共和国国家尊严或有违
                        </p>
                        <p>
                          中华人民共和国公序良俗的信息或内容（“违规内容”）。如果客户在使用
                        </p>
                        <p>
                          平台的服务过程中发现有违规内容的，请客户立即停止浏览、使用或传播该
                        </p>
                        <p>
                          信息，并立即向平台报告。否则，由此带来的一切责任由客户自己承担。
                        </p>
                        <p>
                          请勿使用其他平台进行联系，若脱离本平台产生问题，后果自负。
                        </p>
                        <pre></pre>
                      </div>
                    </div>
                    <div class="submit_top">
                      <div class="submit center ba6e coff ru5">
                        <div
                          class="center ba6e coff ru5 sz14 cursor"
                          @click="submit"
                        >
                          发送
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <p style="max-width:1920px;" v-html="emeildetail.dealEmailContentHtml"></p> -->

              <!-- <div class="statement flex">
                <p class="statement_text">Tips：平台接受处理违规信息的联系方式为：support@foshobrands.com</p>
                <p class="statement_img center ru50 co6e cursor" @mouseenter="mouseover" @mouseleave="mouseout">?</p>
                <div class="statement_pre" v-if="statementStuts == 1">
                </div>
                <div class="submit_top">
                  <div class="submit center ba6e coff ru5">
                    <div class="center ba6e coff ru5 sz14 cursor" @click="submit">发送</div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </el-drawer>
      </div>
      <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="30%"
        top="15%"
        :before-close="handleClose"
        center
      >
        <div class="content flex">
          <div class="content_img">
            <img src="@/assets/img/emil/gg.png" alt="" />
          </div>
          <div>
            <p class="content_p1">已发送</p>
            <p class="content_p2">此邮件发送成功，并已保存到“发件箱”文件夹</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="flex butt">
            <div
              class="butt_two center coff ba6e cursor"
              type="primary"
              @click="gooubox"
            >
              返回发件箱
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
    <email ref="emailTemplate" @templateBack="templateBack"></email>
  </div>
</template>
<script>
import {
  QUERYEMAILSENDLIST,
  EMAILSENDSTARMARK,
  DELSENDEMAIL,
  QUERYEMAILSEND,
  SENDEMAIL,
  QUERY,
} from "../../api/emial";
import { EMAILTEMPLATE, TEMPLATES, REPLYEMAIL } from "../../api/emial"; // 引入接口名称
import { Editor, Toolbar } from "@wangeditor/editor-for-vue"; // 引入子组件
import { DomEditor } from "@wangeditor/editor";
// import { email } from "../../components/EmailTemplate.vue";
export default {
  components: {
    Editor,
    Toolbar,
    email: () => import("@/components/EmailTemplate.vue"),
  },
  data() {
    return {
      checked: true,
      value1: "",
      value2: "",
      value: "",
      emaiList: [], //发件箱列表
      currentPage: 1,
      size: 10,
      receiverName: "", //联盟客姓名
      isRead: "", // 是否已读 0否 1是
      startDate: "", //发送开始日期
      endDate: "", // 发送结束日期
      isStarMark: "", // 是否星标
      total: "",
      chooseAll: false,
      detaillist: [], //选中的数据
      fullscreenLod: false,
      values: "",
      drawer: false, // 邮件详情
      widthSize: "45%",
      zkstyts: 1, // 抽屉展开收起状态 1 收起 2 展开
      emeildetail: {},
      detaStuts: 1,
      statementStuts: 0, // 平台声明 0不显示 1显示
      name: "",
      subject: "",
      templatesList: "",
      editor: null,
      html: "",
      toolbarConfig: {},
      editorConfig: { placeholder: "请输入内容..." },
      mode: "default", // or 'simple',
      texts: "",
      templatesList: [], // 模板列表
      statementStuts: 0, // 平台声明 0不显示 1显示
      subject: "", // 主題
      name: "",
      allianceCode: [],
      zkstyts: 1,
      id: "",
      dialogVisible: false,
      isReadstusts: false,
      readAll: true, // 全部已读
      widthstuts: 1,
      inboxStuts: null,
      validParam: localStorage.getItem("validParam"),
    };
  },
  mounted() {
    if (this.validParam !== "ob") {
      this.$bus.$emit("showNopermiss", true);
    }
    this.querylsi();
    if (this.$route.query.name) {
      this.receiverName = this.$route.query.name;
      this.queryEmailSendList();
    } else {
      this.queryEmailSendList();
    }
    this.templateshtml();
  },
  methods: {
    // 获取登录信息
    querylsi() {
      QUERY().then((res) => {
        if (res.data.code == "nolog") {
          this.$router.push("./");
        } else if (res.data.code == "forceout") {
          // this.$message({
          //   message: '账号在其他地方登录,您被迫下线',
          //   type: 'warning'
          // });
          localStorage.removeItem("token");
        }
      });
    },
    /**  QUERYEMAILSEND
     * queryEmailSendList()
     * 获取发件箱列表
     */
    queryEmailSendList() {
      QUERYEMAILSENDLIST({
        currentPage: this.currentPage,
        size: this.size,
        receiverName: this.receiverName,
        isRead: this.isRead,
        startDate: this.startDate,
        endDate: this.endDate,
      }).then((res) => {
        this.emaiList = [];
        let arr = res.data.body.records;
        arr.map((item) => {
          this.emaiList.push(Object.assign({}, item, { choose: "" }));
          if (item.isRead === 0) {
            this.isReadstusts = true;
          } else {
            this.isReadstusts = false;
          }
        });
        // for (var i = 0; i < this.emaiList.length; i++) {
        //   if (this.emaiList[i].isRead == 1) {
        //     this.readAll = false
        //     break;
        //   }
        // }
        this.total = res.data.body.total;
      });
    },
    /**
     * searchs()
     * 模糊查询
     */
    searchs() {
      this.queryEmailSendList();
    },
    // 格式化开始时间
    startDa(e) {
      if (e === null) {
        this.startDate = e;
        this.endDate = e;
      } else {
        this.startDate =
          e[0].getFullYear() +
          "-" +
          (e[0].getMonth() + 1) +
          "-" +
          e[0].getDate();
        this.endDate =
          e[1].getFullYear() +
          "-" +
          (e[1].getMonth() + 1) +
          "-" +
          e[1].getDate();
      }
    },
    delValue() {
      this.isRead = "";
      // this.queryEmailSendList()
    },
    // 格式化结束时间
    // endDatea(e) {

    // },
    /**
     * starMark()
     * 星标或取消
     */
    starMark(e) {
      EMAILSENDSTARMARK({ id: e.id }).then((res) => {
        this.queryEmailSendList();
      });
    },
    starMarkDe(e) {
      EMAILSENDSTARMARK({ id: e.id }).then((res) => {
        this.queryEmailSendList();
        QUERYEMAILSEND({ id: e.id }).then((res) => {
          this.emeildetail = res.data.body;
          this.name = res.data.body.name;
          this.subject = res.data.body.subject;
          this.id = res.data.body.id;
          this.allianceCode = [res.data.body.allianceCode];
          // this.allianceCode.push(res.data.body.allianceCode)
        });
      });
    },
    // vue hover事件鼠标移入触发
    mouseover() {
      this.statementStuts = 1;
    },
    // vue hover事件鼠标移出触发
    mouseout() {
      this.statementStuts = 2;
    },
    // 详情内星标取消
    detalxb(e) {
      this.fullscreenLod = true;
      EMAILRECEIVESTARMARK({ id: e.id }).then((res) => {
        this.queryEmailSendList();
        QUERYEMAILSEND({ id: e.id }).then((res) => {
          this.emeildetail = res.data.body;
        });
        this.fullscreenLod = false;
      });
    },
    //分页功能
    currentChangeTwo(val) {
      this.currentPage = val;
      this.queryEmailSendList();
    },
    // 删除
    detaile() {
      if (!this.detaillist.length) {
        this.$message({
          message: "请选择需要删除的邮件",
          type: "warning",
        });
        return;
      }
      this.$confirm("确定要删除所选邮件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteEnterprise();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 确定删除
    deleteEnterprise() {
      let ids = this.detaillist.toString();
      DELSENDEMAIL({ ids: ids }).then((res) => {
        if (res.data.code == "success") {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.chooseAll = false;
          this.currentPage = 1;
          this.detaillist = [];
          this.queryEmailSendList();
        }
      });
    },
    inboxlist(index) {
      this.inboxStuts = index;
    },
    // 全选按钮
    chooseAllCart() {
      this.chooseAll = !this.chooseAll;
      // 表中的每一项同步状态
      for (var i = 0; i < this.emaiList.length; i++) {
        this.emaiList[i].choose = this.chooseAll;
      }
      this.detaillist = this.emaiList.map((obj) => {
        return obj.id;
      });
    },
    ctinput() {
      if (!this.chooseAll) {
        this.detaillist = [];
      }
    },
    // 多选按钮
    chooseOne(index, e) {
      this.emaiList[index].choose = !this.emaiList[index].choose;
      for (var i = 0; i < this.emaiList.length; i++) {
        if (this.emaiList[i].choose == false) {
          this.chooseAll = false;
          break;
        }
      }
      if (i == this.emaiList.length) {
        this.chooseAll = true;
      }
      if (e.choose == true) {
        this.detaillist.push(e.id);
      } else {
        this.detaillist.splice(i, 1);
      }
    },
    // 查看邮件详情
    detaleemwi(e) {
      QUERYEMAILSEND({ id: e.id }).then((res) => {
        this.drawer = true;
        this.emeildetail = res.data.body;
        this.name = res.data.body.name;
        // this.subject = res.data.body.subject
        this.id = res.data.body.id;
        this.allianceCode = [res.data.body.allianceCode];
      });
    },
    // 关闭抽屉
    handleCloses() {
      this.drawer = false;
      this.detaStuts = 1;
    },
    // 展开收起
    widthclice(e, d) {
      if (e == 1) {
        this.widthSize = "85.5%";
        this.zkstyts = 2;
        this.widthstuts = 2;
      } else {
        this.widthSize = "45%";
        this.zkstyts = 1;
        this.widthstuts = 1;
      }
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.editor2 = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.toolbarConfig = {
        excludeKeys: [
          "insertVideo",
          "uploadVideo",
          "group-video",
          "group-image",
          "insertLink",
          "fullScreen",
          "codeBlock",
        ],
      };
    },
    onChange(editor) {
      const toolbar = DomEditor.getToolbar(editor);
    },
    // 获取邮件模板
    templateshtml() {
      EMAILTEMPLATE({
        currentPage: 1,
        size: 100,
      }).then((res) => {
        this.templatesList = res.data.body.records;
      });
    },
    // 再发一封
    detaShf() {
      this.detaStuts = 2;
      this.subject = "";
      this.html = "";
      // let str = 'Re:'
      // if (this.subject.indexOf("Re") != -1) {

      // } else {
      //   this.subject = str + this.subject
      // }
    },
    // 发送邮件
    submit() {
      if (!this.subject) {
        this.$message({
          message: "请输入邮件主题",
          type: "warning",
        });
        return;
      }
      if (!this.editor.getText()) {
        this.$message({
          message: "请输入邮件内容",
          type: "warning",
        });
        return;
      }
      let data = {
        allianceCodes: this.allianceCode,
        subject: this.subject,
        contentText: this.editor.getText(),
        contentHtml: this.html,
        // receiveEmailId: this.id
      };
      SENDEMAIL(data).then((res) => {
        if (res.data.code == "error") {
          this.$message({
            message: res.data.msg,
            type: "warning",
          });
        } else {
          this.dialogVisible = true;
          this.allianceCode = [];
          this.drawer = false;
          this.queryEmailSendList();
        }
      });
    },
    // 选择模板
    selicetem(e) {
      this.html = e.content;
    },
    // 返回发件箱
    gooubox() {
      this.dialogVisible = false;
      this.queryEmailSendList();
      this.detaStuts = 1;
      // this.$router.push('./outbox')
      // localStorage.setItem('isemitco', 3)
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 查看详情
    godetil(e) {
      let routeUrl = this.$router.resolve({
        path: "details",
        query: { code: e.allianceCode },
      });
      window.open(routeUrl.href, "_blank");
    },
    openTemplateM() {
      this.$refs.emailTemplate.init();
    },
    templateBack() {
      this.templateshtml();
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.bacc {
  background: rgba(0, 0, 0, 0.05);
}

.w65 {
  width: 65%;
}

.w35 {
  width: 35%;
}

.drawer_center {
  position: relative;

  .sendOut {
    min-width: 750px;
    max-width: 1920px;
    min-height: 50px;
    // position: fixed;
    // bottom: 0px;
    background: #fff;
    padding-bottom: 40px;
  }
}

.read {
  width: 96px;
  height: 40px;
  border-radius: 5px 5px 5px 5px;
  line-height: 40px;
  margin-top: 20px;
}

.sendOuts {
  min-width: 750px;
  max-width: 1920px;
  min-height: 70px;
  position: fixed;
  bottom: 0px;
  background: #fff;
  padding-bottom: 60px;
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
}

.top_center {
  height: 100vh;
}

.inbox {
  padding-top: 112px;
  box-sizing: border-box;
  background: #fafafa;
}

.addressee {
  margin-bottom: 15px;
}

.addressee_input {
  margin-bottom: 20px;
}

.templates {
  width: 100%;
  height: 40px;

  .templates_top {
    float: right;
  }

  .templates_selice {
    width: 206px;
    height: 40px;
    line-height: 40px;
    padding-left: 22px;
    box-sizing: border-box;
    border: 1px solid #d8dee8;
    float: right;
    position: relative;

    i {
      font-size: 26px;
      position: absolute;
      top: 50%;
      right: 20px;
      margin-top: -13px;
    }
  }

  .templates_list {
    width: 206px;
    padding: 24px 0;
  }
}

.statement {
  width: 100%;
  margin-top: 12px;
  position: relative;

  .statement_p {
    // padding-bottom: 15px;
    height: 39px;
    align-items: center;
    position: relative;

    .statement_pre {
      background: #000;
      color: #fff;
      padding: 10px;
      position: absolute;
      left: 0;
      top: -170px;
    }
  }

  .statement_img {
    width: 23px;
    height: 23px;
    line-height: 23px;
    border: 1px solid #be3c6e;
    margin-left: 10px;
  }

  .statement_pre {
    background: #000;
    color: #fff;
    padding-left: 10px;

    pre {
      margin-top: 5px;
    }
  }

  .submit_top {
    width: 97px;
    height: 50px;
    position: absolute;
    right: 0;

    .submit {
      width: 97px;
      height: 39px;
      line-height: 39px;
    }
  }
}

.inlbox {
  width: 100%;
  margin: 0 auto;

  .title_top {
    padding-top: 25px;

    .title {
      height: 56px;
      border: 1px solid #d5d5d5;
      border-radius: 5px;
      background: #fff;

      div {
        height: 100%;
      }

      .title_input {
        width: 300px;
        height: 54px;
        border-right: 1px solid #d5d5d5;
        position: relative;

        .icons {
          width: 16px;
          height: 56px;
          position: absolute;
          right: 10px;
          top: 0;
          display: flex;
          align-items: center;

          img {
            width: 16px;
            height: 16px;
          }
        }
      }

      .title_ks {
        width: 500px;
        border-right: 1px solid #d5d5d5;
        position: relative;

        img {
          width: 34px;
          height: 30px;
          position: absolute;
          left: 30px;
          top: 50%;
          margin-top: -15px;
        }
      }

      .title_scslt {
        width: 284px;
      }
    }

    .title_qu {
      // height: 56px;
      display: flex;
      align-items: center;
      padding-left: 24px;

      .title_query {
        width: 130px;
        height: 40px;
        font-size: 16px;
        line-height: 40px;
      }
    }
  }

  .list {
    width: 100%;
    height: 48px;
    padding: 0 15px;
    margin: 35px 0 55px 0;
    align-items: center;
    font-size: 14px;

    .fixedLef {
      input {
        width: 28px;
        height: 28px;
      }
    }

    .fj {
      width: 20%;
      margin-left: 56px;
    }

    .zt {
      width: 60%;
    }

    .sj {
      width: 5%;
    }

    .detale {
      margin-left: 25px;
      display: inline-block;
      text-decoration: underline #be3c6e;
    }
  }

  .list_map {
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    margin-bottom: 13px;
    align-items: center;
    font-size: 14px;

    input {
      width: 28px;
      height: 28px;
    }

    .fj {
      width: 15%;
      margin-left: 96px;
      height: 100%;
      align-items: center;

      div {
        margin-right: 15px;
        width: 40px;
        height: 40px;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          vertical-align: baseline;
        }

        // height: 38px;
      }

      .receivename {
        max-width: 150px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        vertical-align: baseline;
      }
    }

    .zt {
      width: 65%;
      height: 100%;
      align-items: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      .zt_stuss {
        min-width: 57px;
        height: 22px;
        line-height: 22px;
        background: rgba(190, 60, 110, 0.2);
        border-radius: 5px 5px 5px 5px;
        margin-right: 12px;
      }

      .bark {
        // width: 20%;
        color: #000;
      }

      .bark_two {
        // min-width: 820px;
        width: 600px;
        color: #707070;
        overflow: hidden;
        /*超出的部分隐藏起来。*/
        white-space: nowrap;
        /*不让文本换行,在一行显示*/
        text-overflow: ellipsis;
        /*超出显示...*/
      }
    }

    .sj {
      width: 10%;
      height: 100%;
      text-align: right;

      //   position: relative;
      div {
        width: 100%;
        height: 100%;
        align-items: center;
        // position: absolute;
        // range: 15px;
        display: inline-block;
        line-height: 50px;
      }

      p {
        display: inline-block;
        line-height: 50px;
      }

      .sj_img {
        // width: 30px;
        height: 100%;
        position: relative;

        img {
          display: inline-block;
          width: 30px;
          height: 30px;
          position: absolute;
          right: 0;
          top: 10px;
        }

        span {
          width: 130px;
          display: inline-block;
          position: absolute;
          right: 50px;
        }
      }
    }
  }

  .pagination-container {
    background: none;
  }
}

.drawer_top {
  width: 98%;
}

.emilconten_top {
  width: 100%;
  height: 46px;
  align-items: center;
  position: relative;
  margin-bottom: 35px;

  .emilconten {
    height: 46px;

    img {
      height: 100%;
    }
  }

  .emilconten_xb {
    width: 25px;
    height: 46px;
    margin: 0 12px;

    .emilconten_xb_img {
      height: 50%;

      img {
        width: 25px;
        height: 100%;
        margin-right: 12px;
      }
    }

    div {
      min-width: 500px;
    }
  }

  .createTimeS {
    position: absolute;
    right: 300px;
    // float: right;
    font-size: 14px;
    color: #000;
  }

  .createTimeS_bt {
    margin: 50px 0 35px 0;
  }
}

.emailcontent {
  height: calc(69vh -150px);
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 2px 0px #e1e1e1;
  text-align: center;

  .list {
    width: 220px;
    border-right: 1px solid #e5e5e5;
    .title {
      padding: 11px;
      font-size: 14px;
      font-weight: 600;
      border-bottom: 1px solid #e1e1e1;
    }

    .template {
      height: calc(100% - 62px);
      overflow-y: scroll;

      .item {
        padding: 8px 5px;
        display: flex;
        cursor: pointer;
        justify-content: space-between;
        align-items: center;
        // border-bottom: 1px solid #e1e1e1;

        &:hover {
          color: #be3c6e;
          .el-icon-edit-outline {
            opacity: 1;
          }
          .el-icon-delete {
            opacity: 1;
          }
        }

        .el-icon-edit-outline {
          color: #0c0909;
          margin-right: 8px;
          opacity: 0;
          cursor: pointer;
          padding: 5px;
          border-radius: 3px;

          &:hover {
            background-color: #d5d5d5;
          }
        }
        .el-icon-delete {
          color: #be3c6e;
          margin-right: 8px;
          opacity: 0;
          cursor: pointer;
          padding: 5px;
          border-radius: 3px;
          &:hover {
            background-color: #d5d5d5;
          }
        }
      }
    }
  }
  .emailhtml {
    flex: 1;
    height: 70vh;
  }
}
</style>
<style lang="less">
.outboxs {
  padding-left: 20px;

  .title_input .el-input__inner {
    height: 100%;
    border: none;
  }

  .el-pagination__sizes {
    display: none !important;
  }

  .el-pagination__total {
    display: none !important;
  }

  .el-select .el-input__inner {
    border: none;
  }

  .el-input--suffix .el-input__inner {
    height: 100%;
    // border: none;
  }

  .el-select {
    width: 100%;
  }

  .el-select > .el-input {
    width: 100%;
    height: 100%;
  }

  .el-range-editor.el-input__inner {
    width: 100%;
    border: none;
    padding-left: 50px;
  }

  .el-date-editor .el-range-separator {
    height: 100%;
    line-height: 48px;
  }

  .el-icon-date:before {
    color: #be3c6e;
    font-size: 28px;
  }

  .el-date-editor .el-range__icon {
    line-height: 56px;
    margin-right: 5px;
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background: #be3c6e;
  }

  .el-drawer__wrapper {
    top: 70px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    margin: 0;
  }

  .drawer_center {
    .el-icon-close:before {
      color: #232323;
    }
  }

  .templates_top {
    display: flex;
    gap: 20px;
    .el-popper[x-placement^="bottom"] {
      width: 206px !important;
    }
  }

  .el-icon-date:before {
    display: none !important;
  }
}

.el-icon-arrow-up:before {
  content: "";
}
</style>
